import { render } from "./UserDetailCollection.vue?vue&type=template&id=411b8d5b&scoped=true"
import script from "./UserDetailCollection.vue?vue&type=script&lang=js"
export * from "./UserDetailCollection.vue?vue&type=script&lang=js"

import "./UserDetailCollection.vue?vue&type=style&index=0&id=411b8d5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411b8d5b"]])

export default __exports__